import { IUiState } from "./types";
import { ActionTree } from "vuex";
import { IRootState } from "@/store/types";
import { UI_MUTATIONS } from "./mutations";

export namespace UI_ACTIONS {
  export const TOGGLE_IS_LOADING = "toggleIsLoading";
  export const ADD_TOAST = "addToast";
  export const REMOVE_TOAST_BY_ID = "removeToastById";
}

export const actions: ActionTree<IUiState, IRootState> = {
  [UI_ACTIONS.TOGGLE_IS_LOADING]({ commit }, isLoading) {
    commit(UI_MUTATIONS.TOGGLE_IS_LOADING, isLoading);
  },
  [UI_ACTIONS.ADD_TOAST]({ commit }, { id, text, type, error }) {
    // if an error was passed
    if (error) {
      // set the type to error
      type = "error";

      // if the toast is for a 400 response from the api
      if (
        error.response &&
        error.response.status === 400 &&
        error.response.data
      ) {
        // overwrite the text with the response error message
        let exception: any = error.response.data.exception;
        if (!exception) {
          // if no exception object is present, then the exception
          // probably didn't come from fluent val
          exception = error.response.data;
        }

        if (exception) {
          // check if the error message is an array or single string
          if (Array.isArray(exception)) {
            text = exception.map(ex => ex.errorMessage).join();
          } else {
            text = exception;
          }
        }
      }
    }

    commit(UI_MUTATIONS.ADD_TOAST, { id, text, type });
  },
  [UI_ACTIONS.REMOVE_TOAST_BY_ID]({ commit }, idToRemove) {
    commit(UI_MUTATIONS.REMOVE_TOAST_BY_ID, idToRemove);
  }
};
